import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import type { CoreStoreType } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import {
  ConnectionStatus,
  GameCommunicationMessageType,
  GameCommunicationMetaType,
  GameCommunicationSenderType,
  IGameCommunicationProcessor,
} from '../types';

export interface TimerMessage extends GameCommunicationMessageType {
  value: string;
}
export class GameCommunicationTimerProcessor implements IGameCommunicationProcessor {
  messageName = 'timer';

  process(
    message: TimerMessage,
    store: CoreStoreType,
    sender: GameCommunicationSenderType,
    { connectionStatus, connectionProcedure }: GameCommunicationMetaType
  ): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.Timer);

    const value = Number(message.value) - message.delay / 1000;
    const { config } = store.getState();
    const lastCallSeconds = (config.timings?.bettingLastCall || 0) / 1000;

    const fromReconnect =
      connectionStatus === ConnectionStatus.RECONNECTING || connectionStatus === ConnectionStatus.RECONNECTED;

    // On timer message set isLoadedInActiveRound flag if timer is less than zero, and it is initial websocket connection
    store.dispatch(gameStateActions.setIsLoadedInActiveRound(value <= 0 && !fromReconnect));

    store.dispatch(gameStateActions.setTimer(value));

    connectionProcedure();

    if (fromReconnect && value <= 0) {
      store.dispatch(gameStateActions.resetCurrentGameStatus());
      return;
    }
    if (value > lastCallSeconds) {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.PlaceYourBets));
      return;
    }
    if (value > 0) {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.LastBets));
      return;
    }
  }
}
